import React from "react";
import { Typography, Container, Box, Button } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        color: "#ffffff",
        pb: { xs: 4, sm: 5, md: 6 },
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          textAlign: "center",
          px: { xs: 3, sm: 4 },
        }}
      >
        {/* <Typography
          variant="h4"
          component="h3"
          sx={{
            color: "#000000",

            // mb: { xs: 1, sm: 1.5 },
            fontSize: "clamp(1.7rem, 3vw, 2.1rem)",
          }}
        >
          Connecting, engaging, communicating
        </Typography> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            mt: { xs: 6, sm: 2 },
            // mb: { xs: 2.5, sm: 3 },
          }}
        >
          {/* <Typography variant="h5" component="h2" sx={{ color: "#000000" }}>
            Social:
          </Typography> */}

          <Typography
            variant="h6"
            sx={{
              cursor: "pointer",
              textDecoration: "none",
              color: "#1b5e20",
              "&:hover": {
                color: "#1b5e20",
                textDecoration: "none",
              },
              "&:visited": {
                color: "#1b5e20",
              },
            }}
            component="a"
            href="https://en.wikipedia.org/wiki/Louise_Serpell"
            target="_blank"
            rel="noopener noreferrer"
          >
            Wikipedia
          </Typography>

          <Typography
            variant="h6"
            component="a"
            sx={{
              cursor: "pointer",
              textDecoration: "none",
              color: "#1b5e20",
              "&:hover": {
                color: "#1b5e20",
                textDecoration: "none",
              },
              "&:visited": {
                color: "#1b5e20",
              },
            }}
            href="https://www.linkedin.com/in/louise-serpell-0b318119/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: "#000000",
          px: { xs: 3, sm: 3.5 },
          py: { xs: 1.75, sm: 2 },
          borderRadius: "999px",
          mt: { xs: 2, sm: 2.5 },
            zIndex: 1000,
            transition: "transform 0.2s ease-in-out",
            "&:hover": { 
              cursor: "pointer",
              transform: "scale(1.05)",
            },
          }}
          onClick={() => window.location.href = "mailto:l.c.serpell@sussex.ac.uk"}
        >
          <Typography
            variant="h6"
            sx={{
              px: { xs: 0, sm: 0.5 },
              cursor: "pointer",
              textDecoration: "none",
              color: "#ffffff",
              "&:hover": {
                color: "#ffffff",
                textDecoration: "none",
                cursor: "pointer",
              },
              "&:visited": {
                color: "#ffffff",
              },
            }}
            component="a"
            href="mailto:l.c.serpell@sussex.ac.uk"
          >
            Get in Touch
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
